import React, {Component} from 'react';
import {BackDropCMS} from '../../components/backdrop/backdrop_cms';
import {Button, Grid, TextField, MenuItem, Typography} from 'material-ui';
import Dialog, {
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    withMobileDialog,
} from 'material-ui/Dialog';
import AddPageTagsSelect from './AddPageTagsSelect';
import {Link} from 'react-router-dom';

class AddNewPageDialog extends Component {
    showCreatablePageTypes = (options) => {
        const creatablePageTypes = [];

        options.map((option) =>
            option.can_create === '1'
                ? creatablePageTypes.push({
                      value: option.id,
                      label: option.type,
                  })
                : false
        );

        return creatablePageTypes;
    };

    getPagesWithTags = (options) => {
        const pagesWithTags = [];

        options.map((option) =>
            option.tags === 1 ? pagesWithTags.push(option.id) : false
        );

        return pagesWithTags;
    };

    getTipByPageType = (pageTypes, selectedPageType) => {
        let getTip = '';

        pageTypes.filter((item) => {
            if (item.id === selectedPageType && item.type !== 'Landing') {
                getTip = `* The page ${item.tip}`;
            }

            return '';
        });

        return getTip;
    };

    render() {
        const {
            pageTypes,
            pageTags,
            selectedPageType,
            selectPageType,
            handleSubmit,
            handleClose,
            open,
            classes,
            hasError,
        } = this.props;

        let showMultiSelect = this.getPagesWithTags(pageTypes).includes(
            selectedPageType
        );

        let selectedPageTags = [];

        selectedPageTags = [
            ...selectedPageTags,
            ...this.props.selectedPageTagsDestination,
            ...this.props.selectedPageTagsContinent,
            ...this.props.selectedPageTagsTripFormat,
            ...this.props.selectedPageTagsTypeOfWork,
            ...this.props.selectedPageTagsTypeOfWorkTag,
            ...this.props.selectedPageTagsTypeOfWorkGroup,
            ...this.props.selectedPageTagsAll,
        ];

        let selectHasError = (selected, name) => {
            let selectError = {};

            if (selected.toString().length < 1) {
                selectError = {[name]: true};
            }

            if (selected.toString().length > 0) {
                selectError = {[name]: false};
            }

            return selectError[name];
        };

        let tagsTypes =
            Object.values(pageTags)[0] !== undefined
                ? Object.values(pageTags)[0]
                : {};
        let tagsTypesKeys = Object.keys(tagsTypes);
        let error =
            Object.values(this.props.metaError).find(
                (element) => element === true
            ) !== undefined
                ? true
                : false;
        let destErr =
            tagsTypesKeys.includes('destination') &&
            this.props.selectedPageTagsDestination.length === 0
                ? true
                : false;
        let contErr =
            tagsTypesKeys.includes('continent') &&
            this.props.selectedPageTagsContinent.length === 0
                ? true
                : false;
        let projectFormatErr =
            tagsTypesKeys.includes('project') &&
            this.props.selectedPageTagsTripFormat.length === 0
                ? true
                : false;
        let tripFormatErr =
            tagsTypesKeys.includes('trip_format') &&
            this.props.selectedPageTagsTripFormat.length === 0
                ? true
                : false;
        let typeOfWorkErr =
            tagsTypesKeys.includes('type_of_work') &&
            this.props.selectedPageTagsTypeOfWork.length === 0
                ? true
                : false;
        let towtErr =
            tagsTypesKeys.includes('type_of_work_tag') &&
            this.props.selectedPageTagsTypeOfWorkTag.length === 0
                ? true
                : false;
        let towgErr =
            tagsTypesKeys.includes('type_of_work_group') &&
            this.props.selectedPageTagsTypeOfWorkGroup.length === 0
                ? true
                : false;

        let fieldsHaveErrors =
            showMultiSelect &&
            (destErr ||
                contErr ||
                projectFormatErr ||
                tripFormatErr ||
                typeOfWorkErr ||
                towtErr ||
                towgErr);

        return (
            <Dialog
                open={open}
                onClose={handleClose}
                disableBackdropClick={true}
                BackdropComponent={BackDropCMS}
                maxWidth="md"
                classes={{
                    paper: classes.paper,
                }}
            >
                <DialogTitle>{'Add New Page'}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Please select below the page type you wish to add
                    </DialogContentText>
                    <Grid item xs={12}>
                        <TextField
                            select
                            name="pageType"
                            value={selectedPageType || 0}
                            fullWidth
                            onChange={(event) => {
                                selectPageType(event.target.value);
                            }}
                            className={classes.pageTypeSelects}
                        >
                            <MenuItem
                                key={0}
                                value={0}
                                disabled
                                className={classes.selectMenuItem}
                            >
                                <span className={classes.selectMenuItemSpan}>
                                    Select page type here
                                </span>
                            </MenuItem>
                            {this.showCreatablePageTypes(pageTypes).map(
                                (option) => (
                                    <MenuItem
                                        key={option.value}
                                        value={option.value}
                                        className={classes.selectMenuItem}
                                    >
                                        {option.label}
                                    </MenuItem>
                                )
                            )}
                        </TextField>
                        {showMultiSelect && (
                            <Grid item xs={12}>
                                {pageTags[tagsTypesKeys] !== undefined &&
                                pageTags[tagsTypesKeys].length === 0 &&
                                showMultiSelect ? (
                                    <span>
                                        <Typography
                                            variant="subheading"
                                            color="error"
                                            className={
                                                classes.multiSelectNoTags
                                            }
                                        >
                                            There are no snippets available for
                                            this page!
                                        </Typography>
                                        <Typography
                                            variant="subheading"
                                            color="error"
                                            className={
                                                classes.multiSelectNoTags
                                            }
                                        >
                                            Please go to the
                                            <Link to={'/tags'}>
                                                {' '}
                                                "Tags"
                                            </Link>{' '}
                                            component and add a new tag for this
                                            page type.
                                        </Typography>
                                        <Typography
                                            variant="subheading"
                                            color="error"
                                            className={
                                                classes.multiSelectNoTags
                                            }
                                        >
                                            If it's not linked to any page yet,
                                            it will appear in the dropdown to be
                                            selected.
                                        </Typography>
                                    </span>
                                ) : (
                                    <span>
                                        <Typography
                                            variant="subheading"
                                            className={classes.multiSelectTitle}
                                        >
                                            Type to search and select below the
                                            snippets for this page
                                        </Typography>
                                        <Typography
                                            variant="body1"
                                            color="error"
                                        >
                                            {this.getTipByPageType(
                                                pageTypes,
                                                selectedPageType
                                            )}
                                        </Typography>
                                        <AddPageTagsSelect
                                            pageTags={pageTags}
                                            selectPageTagsDestination={
                                                this.props
                                                    .selectPageTagsDestination
                                            }
                                            selectPageTagsContinent={
                                                this.props
                                                    .selectPageTagsContinent
                                            }
                                            selectPageTagsTripFormat={
                                                this.props
                                                    .selectPageTagsTripFormat
                                            }
                                            selectPageTagsTypeOfWork={
                                                this.props
                                                    .selectPageTagsTypeOfWork
                                            }
                                            selectPageTagsTypeOfWorkTag={
                                                this.props
                                                    .selectPageTagsTypeOfWorkTag
                                            }
                                            selectPageTagsTypeOfWorkGroup={
                                                this.props
                                                    .selectPageTagsTypeOfWorkGroup
                                            }
                                            selectPageTagsAll={
                                                this.props.selectPageTagsAll
                                            }
                                            selectedPageTagsDestination={
                                                this.props
                                                    .selectedPageTagsDestination
                                            }
                                            selectedPageTagsContinent={
                                                this.props
                                                    .selectedPageTagsContinent
                                            }
                                            selectedPageTagsTripFormat={
                                                this.props
                                                    .selectedPageTagsTripFormat
                                            }
                                            selectedPageTagsTypeOfWork={
                                                this.props
                                                    .selectedPageTagsTypeOfWork
                                            }
                                            selectedPageTagsTypeOfWorkTag={
                                                this.props
                                                    .selectedPageTagsTypeOfWorkTag
                                            }
                                            selectedPageTagsTypeOfWorkGroup={
                                                this.props
                                                    .selectedPageTagsTypeOfWorkGroup
                                            }
                                            selectedPageTagsAll={
                                                this.props.selectedPageTagsAll
                                            }
                                            selectHasError={selectHasError}
                                            hasError={hasError}
                                        />
                                    </span>
                                )}
                            </Grid>
                        )}
                    </Grid>
                </DialogContent>
                <DialogActions className={classes.dialogActionsBtn}>
                    <Button onClick={handleClose} variant="raised">
                        Cancel
                    </Button>
                    <Button
                        onClick={(e) =>
                            handleSubmit(selectedPageType, selectedPageTags)
                        }
                        variant="raised"
                        color="primary"
                        type="submit"
                        disabled={
                            selectedPageType.length < 1 ||
                            (error || fieldsHaveErrors)
                        }
                    >
                        Add
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default withMobileDialog()(AddNewPageDialog);



// WEBPACK FOOTER //
// ./src/containers/pages/AddNewPageDialog.jsx